  <!-- Breadcrumb -->
  <!-- <div class="breadcrumb bg-neutral-25 mb-0">
    <div class="container text-opacity-5">
      Home / Auction Search
    </div>
  </div> -->
  <!-- /Breadcrumb -->

  <div class="pt-3 pb-3">
    <router-outlet></router-outlet>
  </div>
